export default {
  today: 'Vandaag',
  tomorrow: 'Morgen',
};
